/* 
 * 接口统一集成模块
 */

 // global
import * as global from './moudules/global'

// model
import * as index from './moudules/index'
import * as device from './moudules/device'
import * as user from './moudules/user'

// system
import * as login from './moudules/login'
import * as role from './moudules/role'
import * as group from './moudules/group'
import * as menu from './moudules/menu'
import * as auth from './moudules/auth'
import * as file from './moudules/file'

// 默认全部导出
export default {
	// global
	global,
	
	// model
	index,
	user,
	device,

	// system
	login,
	role,
	group,
	menu,
	auth,
	file,
}


// WEBPACK FOOTER //
// ./src/http/api.js